module.exports = __webpack_public_path__ + "img/m_footer_bg.74b931e2.png";